<template>
    <v-dialog v-model="show" max-width="500px" persistent>
      <v-card>
        <v-toolbar dense outlined>
          <span class="text-subtitle-1">
            Library
            <v-chip class="ml-2" x-small color="primary">Update</v-chip>
          </span>
          <v-spacer></v-spacer>
          <v-btn icon @click="close">
            <v-icon>mdi-close</v-icon>
          </v-btn>
        </v-toolbar>
        <v-form lazy-validation v-model="valid" ref="updateForm" class="pa-3">
          <v-text-field
            v-model="libraryName"
            hide-details
            clearable
            dense
            outlined
            prepend-inner-icon="mdi-book"
            :rules="rules"
            label="Library name"
          />
          <v-textarea
            v-model="description"
            hide-details
            clearable
            dense
            auto-grow
            outlined
            label="Description"
            class="mt-6"
          />
          <v-file-input
            v-model="image"
            accept="image/*"
            outlined
            dense
            label="Upload new image (optional)"
            prepend-inner-icon="mdi-image"
            show-size
            clearable
            class="mt-6"
          />
          <v-text-field
            v-model="organizations"
            label="Organizations"
            outlined
            dense
            clearable
            prepend-inner-icon="mdi-domain"
          />
          <v-combobox
          class="mb-4"
          v-model="labels"
          label="Labels"
          outlined
          dense
          multiple
          clearable
          deletable-chips
          small-chips
          chips
          hide-details
          hint="Press enter after each version to add"
          prepend-inner-icon="mdi-tag"
        />

          <v-col cols="6">
            <div class="d-flex align-center" style="height: 100%;">
              <v-checkbox
                v-model="isPopular"
                label="Is Popular"
                dense
                hide-details
                class="ma-0 pa-0"
              />
            </div>
          </v-col>
          <div class="d-flex justify-end mt-2">
            <v-btn
              color="primary"
              @click="submit"
              :disabled="!valid || loading"
              :loading="loading"
            >
              Update
            </v-btn>
          </div>
        </v-form>
      </v-card>
    </v-dialog>
  </template>
<script>
import Swal from 'sweetalert2'
import { apiService } from '../../service/api.service'
export default {
  name: 'UpdateLibraryView',
  props: {
    show: Boolean,
    selectedLibrary: Object // { id, name, description, organizations, isPopular, ... }
  },
  data () {
    return {
      libraryName: '',
      isPopular: false,
      organizations: '',
      labels: '',
      image: null,
      description: '',
      valid: true,
      loading: false,
      rules: [
        v => !!v || 'This field is required.'
      ]
    }
  },
  watch: {
    // show true olduğunda ve id değiştiğinde veriyi çek
    selectedLibrary: {
      handler (val) {
        if (val) {
          this.libraryName = val.name || ''
          this.description = val.description || ''
          this.organizations = val.organizations || ''
          this.isPopular = val.isPopular || false
        }
      },
      immediate: true
    }
  },
  methods: {
    close () {
      this.resetForm()
      this.$emit('update:show', false)
    },
    resetForm () {
      this.libraryName = ''
      this.description = ''
      this.organizations = ''
      this.image = null
      this.isPopular = false
      this.labels = ''
    },
    submit () {
      if (!this.selectedLibrary?.id) {
        Swal.fire('Error!', 'Selected library ID is missing.', 'error')
        return
      }
      this.loading = true
      const formData = new FormData()
      formData.append('id', this.selectedLibrary.id)
      formData.append('name', this.libraryName)
      formData.append('definition', this.description)
      formData.append('organizations', this.organizations)
      formData.append('isPopular', this.isPopular)
      formData.append('labels', this.labels)
      if (this.image) {
        formData.append('file', this.image)
      }
      apiService
        .put('admin/update-parent-exp', formData, {
          headers: {
            'Content-Type': 'multipart/form-data'
          }
        })
        .then((res) => {
          if (res.data.ok) {
            Swal.fire('Success!', 'Library updated successfully.', 'success')
            this.close()
          } else {
            throw new Error(res.data.message || 'Update failed.')
          }
        })
        .catch((error) => {
          Swal.fire('Error!', error.response?.data?.message || error.message, 'error')
        })
        .finally(() => {
          this.loading = false
        })
    }
  }
}
</script>
